<template>
  <div>
    <v-dialog
      max-width="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Days Off
          <v-spacer></v-spacer>
          <v-text-field
            dense
            clearable
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search event"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            :headers="days_off_headers"
            :items="localDaysOff"
            :key="tableKey"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, -1]
            }"
          >
          <template v-slot:[`item.EventDate`]="{ item }">
              {{ item.EventDate | dateFilter }}
            </template>
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn icon small
                @click.prevent="getDayOffDetailsById(item.ID)"
                color="primary"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
              <v-btn icon small
                color="red darken-2"
                @click.prevent="deleteDayOff(item.ID)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="addNewdayOff">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteDayOffDialog"
      v-model="deleteDayOffDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="removeDayOff"
      @onCancelClick="deleteDayOffDialog = false"
      @onCloseClick="deleteDayOffDialog = false"
    />
    <DaysOffEditor
      v-model="showDaysOffEditor"
      :addMode="addMode"
      :currentDayOff="selectedDayOff"
      @onAdded="onDayOffAdded"
      @onUpdated="onDayOffUpdated"
    ></DaysOffEditor>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
export default {
  name: 'DaysOffManager',
  props: {
    value: {
      required: false
    },
    daysoff: {
      required: false,
      default: () => []
    }
  },
  components: {
    DaysOffEditor: () => import('@/components/days_off/DaysOffEditor.vue'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  data () {
    return {
      localDaysOff: [],
      tableKey: 0,
      addMode: false,
      showEditor: false,
      selectedDayOff: {},
      search: '',
      deleteDayOffDialog: false,
      days_off_headers: [
        {
          text: 'Event Date',
          value: 'EventDate',
          divider: true,
          width: '25%',
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Description',
          value: 'EventDescription',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    showDaysOffEditor: {
      get () {
        return this.showEditor
      },
      set (value) {
        this.showEditor = value
      }
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    daysoff: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.localDaysOff = [...newVal]
        this.updateTableKey()
      }
    }
  },
  methods: {
    updateTableKey () {
      this.tableKey += 1
    },
    onDayOffAdded () {
      this.getDaysOffFromServer()
    },
    getDaysOffFromServer () {
      this.axios.get('/api/daysoff', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.localDaysOff = res.data
        this.$emit('update:daysoff', this.localDaysOff)
        this.updateTableKey()
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    onDayOffUpdated (updatedItem) {
      const index = this.localDaysOff.findIndex(item => item.ID === updatedItem.ID)
      if (index !== -1) {
        const newDaysOff = [...this.localDaysOff]
        newDaysOff[index] = Object.assign({}, updatedItem)
        this.localDaysOff = newDaysOff
        this.$emit('update:daysoff', this.localDaysOff)
        this.updateTableKey()
      }
    },
    getDayOffDetailsById (id) {
      this.axios.get(`/api/dayoff/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const data = res.data[0]
        data.EventDate = formatLocalDate(new Date(data.EventDate))
        this.selectedDayOff = data
        this.addMode = false
        this.showDaysOffEditor = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewdayOff () {
      this.selectedDayOff = {
        ID: null,
        EventDate: formatLocalDate(new Date()),
        EventDescription: ''
      }
      this.addMode = true
      this.showDaysOffEditor = true
    },
    deleteDayOff (id) {
      this.selectedDayOff.ID = id
      this.deleteDayOffDialog = true
    },
    removeDayOff () {
      this.axios.delete(`/api/daysoff/${this.selectedDayOff.ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.localDaysOff = this.localDaysOff.filter(item => item.ID !== this.selectedDayOff.ID)
        this.$emit('update:daysoff', this.localDaysOff)
        this.updateTableKey()
        this.$store.dispatch('setSuccess', { successMsg: 'Day off successfully deleted' })
        this.deleteDayOffDialog = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  filters: {
    dateFilter (val) {
      return val ? formatLocalDate(new Date(val)) : ''
    }
  }
}
</script>
